import { vendorStatsPaths } from './vendorStatsApi';

export const VENDOR_ANALYTICS_PERIODS = ['weekly', 'monthly', 'yearly', 'all'];

export const DEFAULT_VENDOR_ANALYTICS_PERIOD = 'monthly';

export async function fetchVendorAnalyticsSummary(period = DEFAULT_VENDOR_ANALYTICS_PERIOD) {
  const response = await fetch(`${vendorStatsPaths.summary}?period=${encodeURIComponent(period)}`, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error('Failed to fetch vendor analytics summary');
  }

  return response.json();
}

export function normalizeTrendSeries(data = []) {
  if (!Array.isArray(data) || data.length === 0) {
    return [0];
  }
  return data;
}
